import { render } from "./ShipTrackTextUpdatesModal.vue?vue&type=template&id=1a5b4619&scoped=true"
import script from "./ShipTrackTextUpdatesModal.vue?vue&type=script&lang=js"
export * from "./ShipTrackTextUpdatesModal.vue?vue&type=script&lang=js"

import "./ShipTrackTextUpdatesModal.vue?vue&type=style&index=0&id=1a5b4619&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5b4619"]])

export default __exports__